import type { IndexedParams, Route, RouteContext } from "@vaadin/router";
import { cookiebot } from "./functions/cookiebot";
import { OrderByOptions } from "./orderby.enum";
import type { Content } from "./entities";
import { UmbMarketList } from "./views/list";

let _content: Content;

function getElementWithParams(params: IndexedParams): UmbMarketList {
  const el = document.createElement("umb-market-list") as UmbMarketList;
  el.params = params;
  return el;
}

export const routes: ReadonlyArray<Route> = [
  {
    path: "/package/:id*",
    component: "umb-market-home",
  },
  {
    path: "/embed/:id*",
    component: "umb-market-package",
  },
  {
    path: "/",
    component: "umb-market-home",
  },
  {
    path: "/search/:id*",
    action: () =>
      getElementWithParams({
        query: "text",
        orderBy: OrderByOptions.Relevance,
      }),
  },
  {
    path: "/category/:id?",
    action: () =>
      getElementWithParams({
        query: "categoryId",
      }),
  },
  {
    path: "/type/:id?",
    action: () =>
      getElementWithParams({
        query: "packageType",
      }),
  },
  {
    path: "/author/:id?",
    action: () =>
      getElementWithParams({
        query: "ownedBy",
      }),
  },
  {
    path: "/tag/:id?",
    action: (context: RouteContext) =>
      getElementWithParams({
        query: "tags",
        pageTitle: `Packages by tag: <strong>${context.params.id}</strong>`,
        showClear: "1",
      }),
  },
  {
    path: "/awards/hall-of-fame",
    action: () =>
      getElementWithParams({
        pageTitle: "Package Hall of Fame",
        pageDescription:
          "Explore the packages inducted into the Umbraco Package Hall of Fame.",
        query: "hallOfFameOnly",
      }),
  },
  {
    path: "/awards/:id?",
    action: () =>
      getElementWithParams({
        pageTitle: "Package award winners {id}",
        pageDescription:
          "Explore the winners, runners up and nominees from the {id} Umbraco Package Awards.",
        query: "awardWinnerInYear",
      }),
  },
  {
    path: "/listing",
    component: "umb-market-content",
    action: async () => {
      _content = (await import("./content/listing")).content;
    },
  },
  {
    path: "/cookies",
    component: "umb-market-content",
    action: async () => {
      _content = (await import("./content/cookies")).content;
      cookiebot(_content);
    },
  },
  {
    path: "/acceptable-use",
    component: "umb-market-content",
    action: async () => {
      _content = (await import("./content/acceptable-use")).content;
      cookiebot(_content);
    },
  },
  {
    path: "/all",
    component: "umb-market-list",
  },
  {
    path: "/all/:orderBy",
    component: "umb-market-list",
    action: (routeContext) =>
      getElementWithParams({
        orderBy: routeContext.params.orderBy!,
      }),
  },
  {
    path: "/validate",
    component: "umb-market-validate",
  },
  {
    path: "/error/:code",
    component: "umb-market-error",
  },
  {
    path: "(.*)",
    component: "umb-market-error",
  },
];

export function getRouteContent() {
  return _content;
}
